<template>
  <b-modal ref="fuel-depo-card-modal" @ok="fuelDepoCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.fuelDepos.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.fuelDepos.tableColumns.ownerCode"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="fuelDepo.ownerCode"
          :state="isOwnerCodeValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.fuelDepos.tableColumns.departmentCode"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="fuelDepo.departmentCode"
          :state="isDepartmentCodeValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.fuelDepos.tableColumns.searpCode"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="fuelDepo.searpCode"
          :state="isSearpCodeValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { azkService } from "../../../../services";

export default {
  name: "UpdateFuelDepoPage",
  props: {
    fuelDepo: Object,
    globalSettings: Array,
  },
  components: {},
  data() {
    return {
      isOwnerCodeValid: null,
      isDepartmentCodeValid: null,
      isSearpCodeValid: null,
      created: null,
      updated: null
    };
  },
  methods: {
    async open() {
      this.isOwnerCodeValid = null;
      this.isDepartmentCodeValid = null;
      this.isSearpCodeValid = null;

      this.$refs["fuel-depo-card-modal"].show();
    },
    async fuelDepoCardModalOk(event) {
      if (!this.fuelDepo.ownerCode) {
        this.isOwnerCodeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isOwnerCodeValid = null;
      }

      if (!this.fuelDepo.departmentCode) {
        this.isDepartmentCodeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isDepartmentCodeValid = null;
      }

      if (!this.fuelDepo.searpCode) {
        this.isSearpCodeValid = false;
        event.preventDefault();
        return;
      } else {
        this.isSearpCodeValid = null;
      }

      const currentGlobalSettings = this.globalSettings.filter(x => x.fuelDepoId == this.fuelDepo.id);

      const createdGlobalSettings = [];
      const updatedGlobalSettings = [];

      const ownerCodeSetting = currentGlobalSettings.find(x => x.name == 'ownerCode');

      if (ownerCodeSetting) {
          ownerCodeSetting.value = this.fuelDepo.ownerCode;
          updatedGlobalSettings.push(ownerCodeSetting);
      } else {
          createdGlobalSettings.push({
              id: 0,
              name: 'ownerCode',
              value: this.fuelDepo.ownerCode
          });
      }

      const departmentCodeSetting = currentGlobalSettings.find(x => x.name == 'departmentCode');

      if (departmentCodeSetting) {
          departmentCodeSetting.value = this.fuelDepo.departmentCode;
          updatedGlobalSettings.push(departmentCodeSetting);
      } else {
          createdGlobalSettings.push({
              id: 0,
              name: 'departmentCode',
              value: this.fuelDepo.departmentCode
          });
      }

      const searpCodeSetting = currentGlobalSettings.find(x => x.name == 'searpCode');

      if (searpCodeSetting) {
          searpCodeSetting.value = this.fuelDepo.searpCode;
          updatedGlobalSettings.push(searpCodeSetting);
      } else {
          createdGlobalSettings.push({
              id: 0,
              name: 'searpCode',
              value: this.fuelDepo.searpCode
          });
      }

      let createGlobalSettingResponse = null;
      if (createdGlobalSettings.length != 0) {
          createGlobalSettingResponse = await azkService.createGlobalSettings(this.fuelDepo.clientId, createdGlobalSettings);
      }

      let updateGlobalSettingResponse = null;
      if (updatedGlobalSettings.length != 0) {
          updateGlobalSettingResponse = await azkService.updateGlobalSettings(updatedGlobalSettings);
      }

      if ((createGlobalSettingResponse != null && createGlobalSettingResponse.isSuccess) || (updateGlobalSettingResponse != null && updateGlobalSettingResponse.isSuccess)) {
        this.$emit("fuelDepoUpdatedSuccessEvent");
      } else {
        this.$emit("fuelDepoUpdatedFailEvent");
      }
    },
  },
};
</script>
